import React from 'react';
import './banner.css';

function Banner(){
    return <section id="banner">
                <div className="row">
                       
                       <div className="col-lg-4">
                       <img src="/images/Telaweb02.jpg" className="image"/>
                       </div>
                       <div className="col-lg-6">
                         <img src="/images/logo8.png" className="image2"/>
                       <h1> Atualize seus dados pessoais</h1>
                       <h3> Acompanhe o andamento do seu processo jurídico do PSS</h3>
                       <a href="/app/novaconta" className="btn btn-dark btn-lg btn-banner btn-teste1"> Criar Conta</a>
                       <a href="/app" className="btn btn-light btn-lg btn-banner btn-teste2"> Fazer Login</a>
                       <a href="/app/filiar" className="btn btn-warning btn-lg btn-banner btn-teste3"> Filie-se</a>
                       </div>

                    
                </div>


            </section>
           
  }

  export default Banner;